var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.iszoomed && !_vm.hasHidden)?_c('div',{staticClass:"zoom-note"},[_c('img',{attrs:{"src":require("images/boundaries/zoom-icon.svg"),"alt":""}}),_c('p',[_vm._v("Pinch the screen to zoom and move.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }